
<template>
  <!-- 入库 -->
  <div class="no-group">
    <!-- 表格 -->
    <div class="group-content">
      <div class="group-title">患者管理 _不入组</div>
      <div>
        <textarea placeholder="请输入不入组原因......如就诊日期、门诊号为空" name id cols="30" rows="10"></textarea>
      </div>
      <div style="margin-top:10px">
        <a-button type="primary">确定</a-button>
        <a-button style="margin-left:20px">取消</a-button>
      </div>
    </div>
  </div>
</template>

<script>
// import PopupContainer from "@/components/common/popupContainer.vue";

export default {
  data() {
    return {
      deptAry: [
        {
          key: 0,
          value: "康圣达*****专业组"
        },
        {
          key: 1,
          value: "****测序中心"
        }
      ]
    };
  },
  methods: {}
};
</script>
<style>
.no-group .popup-container .header {
  height: 40px;
}
</style>
<style lang="scss" scoped>
.group-content {
  height: 500px;
  width: 386px;
  margin: 0 auto;
  .group-title {
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    margin-bottom: 52px;
  }

  textarea {
    width: 386px;
    height: 202px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(66, 142, 247, 1);
  }
}
.table-th {
  color: #a4a4a4;
}
.sure-button {
  width: 680px;
  margin: 50px auto 0;
  padding-bottom: 50px;
  .ant-btn {
    height: 42px;
  }
}
</style>